import React from 'react';

import { useProductPersonalisedText } from '@hooks/directusHooks/useProductPersonalisedText';
import Image from '@components/image/image';

import styles from './why-choose-vitl.module.scss';

const WhyChooseVitl = () => {
  const { directusProductPersonalised } = useProductPersonalisedText();

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2>{directusProductPersonalised.quality_title}</h2>
        <hr />
        <p className={styles.qualityText}>{directusProductPersonalised.quality_description}</p>
        <div className={styles.qualityIngredientsImages}>
          <Image filename={directusProductPersonalised.quality_image_1.filename_disk} width={500} />
          <Image filename={directusProductPersonalised.quality_image_2.filename_disk} width={500} />
        </div>
      </div>
    </section>
  );
};

export default WhyChooseVitl;
